// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tagging__container {
  margin-left: 1rem;
  display: block;
}

.tagging__container__box__second {
  margin-top: 1rem;
}

.tagging__row {
  padding: 1rem;
  margin: 0;
  display: flex;
  width: 20vw;
  box-shadow: -8px 0px 8px -5px rgb(147 139 139 / 75%) inset;
}

.box__tagging {
  margin: 0 1rem;
  display: block;
}

.box__tagging:first-child {
  margin: 0 1rem 0 0;
}

.tagging__container__box__first {
  display: flex;
}

.tagging__wrapper {
  width: 50%;
  text-align: start;
}

.tagging__wrapper p {
  font-size: var(--caption);
}

.tagging__wrapper:last-child {
  text-align: center;
  width: 50%;
}

.tagging__title {
  padding: 5px 0px;
  margin: 0;
  font-size: var(--caption);
}

.tagging__btn {
  border: none;
  background: none;
  font-weight: 700;
  padding: 0.4rem;
  transition-duration: 0.4s;
}

.tagging__btn:hover {
  background-color: #d2d3d2;
  border-radius: 7%;
  color: white;
}

.tag__autocomplete {
  width: 300px;
}

.tag__autocomplete div div div {
  top: 0 !important
}

.tag__autocomplete div div input {
  padding: 0 0 0 10px!important;
  height: 35px !important;
}

.tag__autocomplete div div{
  padding: 5px !important;
}

.tagging__wrapper__autocomplete__title {
  font-family: 'Segoe UI';
  font-style: normal;
  font-weight: normal;
  font-size: var(--subheader);
  margin: 1rem 0 0.5rem 0;
}

.text__field__tagging {
  border-radius: 5px;
  width: 300px;
  color: rgb(199 198 197);
}

.disabledTagging {
  background: rgb(238, 237, 237);
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/RulesConfiguration/components/createTab/Tagging/Tagging.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,WAAW;EACX,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".tagging__container {\n  margin-left: 1rem;\n  display: block;\n}\n\n.tagging__container__box__second {\n  margin-top: 1rem;\n}\n\n.tagging__row {\n  padding: 1rem;\n  margin: 0;\n  display: flex;\n  width: 20vw;\n  box-shadow: -8px 0px 8px -5px rgb(147 139 139 / 75%) inset;\n}\n\n.box__tagging {\n  margin: 0 1rem;\n  display: block;\n}\n\n.box__tagging:first-child {\n  margin: 0 1rem 0 0;\n}\n\n.tagging__container__box__first {\n  display: flex;\n}\n\n.tagging__wrapper {\n  width: 50%;\n  text-align: start;\n}\n\n.tagging__wrapper p {\n  font-size: var(--caption);\n}\n\n.tagging__wrapper:last-child {\n  text-align: center;\n  width: 50%;\n}\n\n.tagging__title {\n  padding: 5px 0px;\n  margin: 0;\n  font-size: var(--caption);\n}\n\n.tagging__btn {\n  border: none;\n  background: none;\n  font-weight: 700;\n  padding: 0.4rem;\n  transition-duration: 0.4s;\n}\n\n.tagging__btn:hover {\n  background-color: #d2d3d2;\n  border-radius: 7%;\n  color: white;\n}\n\n.tag__autocomplete {\n  width: 300px;\n}\n\n.tag__autocomplete div div div {\n  top: 0 !important\n}\n\n.tag__autocomplete div div input {\n  padding: 0 0 0 10px!important;\n  height: 35px !important;\n}\n\n.tag__autocomplete div div{\n  padding: 5px !important;\n}\n\n.tagging__wrapper__autocomplete__title {\n  font-family: 'Segoe UI';\n  font-style: normal;\n  font-weight: normal;\n  font-size: var(--subheader);\n  margin: 1rem 0 0.5rem 0;\n}\n\n.text__field__tagging {\n  border-radius: 5px;\n  width: 300px;\n  color: rgb(199 198 197);\n}\n\n.disabledTagging {\n  background: rgb(238, 237, 237);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
